import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField'
import * as PasswordMutation from '../mutations/PasswordMutation'
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import CheckIcon from 'material-ui/svg-icons/navigation/check';

const closeBtn = {
    cursor: 'pointer',
    float: 'right',
    marginTop: -5,
    marginRight: -14,
    width: 26,
    height: 26
};
const modalStyle = {
    main: {
        width: 460
    },
    title: {
        padding: '25px 30px 13px 30px',
        fontSize: 24
    },
    body: {
        padding: '0 29px 0 31px',
        minHeight: '236px'
    },
    footer: {
        padding: '20px 30px'
    }
};
const textFieldStyle = {
    main: {
        marginBottom: -1
    },
    underlineFocus: {
        // borderBottom: '2px solid #888'
    },
    labelStyle: {
        color: '#777',
        fontSize: 16,
        top: 37
    },
    errorStyle: {
        color: '#D0021B',
        position: 'absolute',
        right: 0,
        bottom: -9
    }
};

const btnStyle = {
    width: 143,
    height: 36,
    borderRadius: 3,
    color: '#fff'
};

const checkIconStyle = {
    show: {
        position: 'absolute',
        right: 0,
        top: 40,
        width: 24,
        height: 24
    },
    hide: {
        display: 'none'
    }
}

class UserChangePassword extends React.Component {
    
    constructor(props: any) {
        super(props);
        
        this.state = {
            currentPassword: '',
            newPassword: '',
            newPasswordCorrect: ''
        }
    }
    
    componentWillReceiveProps() {
        this.setState({
            oldPassword: '',
            password: '',
            newPasswordCorrect: ''
        })
    }
    
    changePassword = () => {
        PasswordMutation.commit(this.props.relay.environment, this.state, (error: string, clientMutationId: string) => {
            if (error != null) {
                alert(error);
                return
            }
            this.props.onChange();
        })
    };
    
    handleClose = () => {
        this.props.onChange();
    };
    
    render() {
        const fieldFull = (this.state.oldPassword === '' ||
            this.state.password === '' ||
            this.state.newPasswordCorrect === '' ||
            (this.state.password !== this.state.newPasswordCorrect));
        const newPasswordCheck = (this.state.password === '' ||
            this.state.newPasswordCorrect === '' ||
            (this.state.password !== this.state.newPasswordCorrect));
        const actions = [
            <FlatButton
                label="Сохранить"
                backgroundColor={fieldFull ? '#e0e0e0' : "#46BC98"}
                hoverColor='#2A9F7C'
                style={btnStyle}
                labelStyle={{fontWeight: 'normal', display: 'block', marginTop: 3}}
                disabled={fieldFull}
                onClick={this.changePassword.bind(this)}/>,
        ];
        
        return (
            <Dialog
                modal={true}
                contentStyle={modalStyle.main}
                open={this.props.open}
                actions={actions}
                title={
                    <div>
                        Сменить пароль
                        <CloseIcon style={closeBtn} color='#542376' onClick={this.handleClose}/>
                    </div>
                }
                titleStyle={modalStyle.title}
                bodyStyle={modalStyle.body}
                actionsContainerStyle={modalStyle.footer}
                overlayStyle={{backgroundColor: 'rgba(0, 0, 0, .1)'}}
            >
                
                <div style={{position: 'relative'}}>
                    <CheckIcon style={(this.state.oldPassword === '') ? checkIconStyle.hide : checkIconStyle.show}
                        color='#46bc98'/>
                    <TextField
                        value={this.state.oldPassword}
                        floatingLabelText="Старый пароль"
                        style={textFieldStyle.main}
                        floatingLabelStyle={textFieldStyle.labelStyle}
                        underlineFocusStyle={textFieldStyle.underlineFocus}
                        type="password"
                        fullWidth={true}
                        onChange={(e, v) => this.setState({oldPassword: v})}/>
                </div>
                <div style={{position: 'relative'}}>
                    <CheckIcon style={newPasswordCheck ? checkIconStyle.hide : checkIconStyle.show}
                        color='#46bc98'/>
                    <TextField
                        value={this.state.password}
                        floatingLabelText="Новый пароль"
                        style={textFieldStyle.main}
                        floatingLabelStyle={textFieldStyle.labelStyle}
                        underlineFocusStyle={textFieldStyle.underlineFocus}
                        type="password"
                        fullWidth={true}
                        onChange={(e, v) => this.setState({password: v})}/>
                </div>
                <div style={{position: 'relative'}}>
                    <CheckIcon style={newPasswordCheck ? checkIconStyle.hide : checkIconStyle.show}
                        color='#46bc98'/>
                    <TextField
                        value={this.state.newPasswordCorrect}
                        floatingLabelText="Повторите пароль"
                        style={textFieldStyle.main}
                        floatingLabelStyle={textFieldStyle.labelStyle}
                        underlineFocusStyle={textFieldStyle.underlineFocus}
                        errorStyle={textFieldStyle.errorStyle}
                        errorText={(this.state.password !== this.state.newPasswordCorrect) ? "пароли не совпадают" : null}
                        type="password"
                        fullWidth={true}
                        onChange={(e, v) => this.setState({newPasswordCorrect: v})}/>
                </div>
            </Dialog>
        )
    }
}

export default UserChangePassword;


// WEBPACK FOOTER //
// src/components/UserChangePassword.js